<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row">

        <div class="col form-group">
        </div>

        <AppSearch 
          v-show="false"
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadLease" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-bind:filterAttr="{ disabled: 1}"
        v-on:filter-data-change="onFilterCarparkChange" >
        <label>
          Car Park
        </label>
      </AppFilter>

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-bind:filterAttr="{ disabled: 1}"
        v-on:filter-data-change="onFilterLicenseChange" >
        <label>
          Parking License
        </label>
      </AppFilter>

      <AppFilter 
        ref="passcardFilter" 
        filterKey="passcardID"
        v-bind:filterAttr="{ disabled: 1}"
        v-on:filter-data-change="onFilterPasscardChange" >
        <label>
          Passcard
        </label>
      </AppFilter>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <AppForm
        v-show="showTerminationApplication"
        ref="pageFormApplication" 
        v-bind:formParameter="APPLICATION_PARAM"
        v-on:form-input="onFormInput"/>

      <TemplateButton 
        v-show="showTerminationApplication"
        class="btn btn-rounded btn-info btn-block-xs-only"
        v-on:click="onSubmitButtonClick">
        Submit
      </TemplateButton>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  // {
  //   key: '_index',
  //   index: true,
  // },
  // {
  //   key: 'parkingLicense',
  //   text: 'Parking License',
  //   table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
  //     let parameterItem = dataParameter[parameterIndex];
  //     let dataItem = dataResult[dataIndex];
  //     return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem['_licenseID']}">${helper.plFormPLNum(dataItem['_licenseNum'], dataItem['_carparkNum'])}</a>`;
  //   },
  //   form_hide: true, 
  // },
  // {
  //   key: '_customerAccount',
  //   text: 'Account Holder',
  //   table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
  //     let parameterItem = dataParameter[parameterIndex];
  //     let dataItem = dataResult[dataIndex]['_customer'];
  //     return `${dataItem.name}<br>${dataItem.nationalID}`;
  //   },
  //   form_hide: true, 
  // },
  // {
  //   key: '_carparkName',
  //   text: 'Car Park',
  // },
  // {
  //   key: '_zoneName',
  //   text: 'Zone',
  // },
  {
    key: '_productName',
    text: 'Product Name',
  },
  {
    key: '_parkingFeesText',
    text: 'Parking Fees (RM)',
  },
  {
    key: '_termination',
    text: 'Termination Effective Date',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem['_termination']) {
        return;
      }
      return helper.formatDate(dataItem['_termination']['terminationDate']);
    },
  },
  {
    key: '_parkerInformation',
    text: 'Parker Information',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

const APPLICATION_PARAM = [
  {
    key: 'conditions',
    text: 'Passcard Condition',
    form_select: ['Good', 'Damaged'],
    form_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'staffID',
    text: 'Staff Name',
    form_select: [],
    form_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'staffNo',
    text: 'Staff No',
    form_input_attr: {
      disabled: true,
    },
  },
];
const APPLICATION_PARAM_MAP = helper.transformParamToMap(APPLICATION_PARAM);

export default {
  name: "PagePasscardTerminationApplicationView",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'Termination Passcard Return' },
        { name: 'Application' },
      ],

      PARAM,
      PARAM_MAP,

      APPLICATION_PARAM,
      APPLICATION_PARAM_MAP,

      pageStaff: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageTermination: null,
      pagePasscardReturn: null,
      pageLease: null,
      pageSeason: null,
      pageFees: {},
      pageParker: null,

      showTerminationApplication: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/passcardTerminationApplication');
    });
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.$refs['passcardFilter'].formatFilterOptionValue = dataItem => dataItem['_passcard'] ? dataItem['id'] : '';
    this.$refs['passcardFilter'].formatFilterOptionText = dataItem => dataItem['_passcard'] ? `${dataItem['_passcard']['sku']} - ${dataItem['_parker']['name']}` : '';
    this.loadStaff();
  },
  methods: {
    loadStaff() {
      let feedbackItem = 'staff data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            helper.inputSelectSetOption(this.APPLICATION_PARAM_MAP['staffID'], this.pageStaff = response.data);
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.loadZone();
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadPasscardType();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No passcard available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/license/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadPasscard();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/passcard/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadTerminationApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadTerminationApplication() {
      let feedbackItem = 'termination license';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/request/?type1=termination',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageTermination = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPasscardReturnApplication();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardReturnApplication() {
      let feedbackItem = 'passcard return application';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + this.$route.query.applicationID + '&type1=passcardReturn',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasscardReturn = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPasscardReturnApplicationData(response.data[0].applicationData);
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardReturnApplicationData(applicationData) {
      let feedbackItem = 'passcard return application data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/applicationData/' + applicationData,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasscardReturn = Object.assign(response.data, this.pagePasscardReturn);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      this.$refs['pageTable'].setTableData(this.pageLease = null);

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = this.getUrl(this.$refs['licenseFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');

          response.data.forEach(lease1 => {
            response.data.forEach(lease2 => {
              if(lease1.leaseNum !== lease2.leaseNum) {
                return;
              }

              if(lease1.type === 'Terminate' && lease2.type === 'Terminate') {
                if(lease1.createDate < lease2.createDate) {
                  lease1.terminateNum = lease2.applicationNum;
                } else {
                  lease2.terminateNum = lease1.applicationNum;
                }
              } else if(lease1.type === 'Terminate') {
                lease2.terminateNum = lease1.applicationNum;
              } else if(lease2.type === 'Terminate') {
                lease1.terminateNum = lease2.applicationNum;
              }

              if(lease1.passcardID && lease2.passcardID) {
                if(lease1.createDate < lease2.createDate) {
                  lease1.passcardID = lease2.passcardID;
                } else {
                  lease2.passcardID = lease1.passcardID;
                }
              } else if(lease2.passcardID) {
                lease1.passcardID = lease2.passcardID;
              } else if(lease1.passcardID) {
                lease2.passcardID = lease1.passcardID;
              }
            });
          });
          
          this.pageLease = response.data.filter(k => k.applicationNum === this.pagePasscardReturn[0].applicationNum);

          if(this.pageLease.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('This parking license do not have any "pending termination" or "terminated without passcard returned" product subscription.');
            return;
          }

          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(this.checkSeasonFees()) {
        return;
      }

      this.$refs['pageFormApplication'].setForm();
      this.pageLease.forEach(k => {
        k['_license'] = this.$refs['licenseFilter'].filterData.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        k['_licenseID'] = k['_license']['id'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];

        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']);
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']);
        k['_parkerInformation'] = helper.plFormParker(k['_parker']);

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;

        if(k['passcardID']) {
          k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID']));
        }

        k['_termination'] = this.pageTermination.find(j => j['applicationNum'] === k['terminateNum']);

        k['_parkingFees'] = this.pageFees[k['seasonID']];
        switch(parseInt(k['paymentPlan'])) {
          case 1:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['monthly']) + ' / month';
            break;
          case 2:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['quarterly']) + ' / quarter';
            break;
          case 3:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['halfYearly']) + ' / half-year';
            break;
          case 4:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['annually']) + ' / annual';
            break;
        }
      });

      this.$refs['passcardFilter'].setFilterData(this.pageLease);
      this.$refs['passcardFilter'].filterValue = this.pageLease[0].id;
      this.onFilterPasscardChange();
      // this.$refs['pageTable'].setTableData(this.pageLease);

      // if(window.location.href.includes('localhost')) {
      //   this.$refs['passcardFilter'].filterValue = 30;
      //   this.$refs['pageFormApplication'].formData['conditions'] = 'Good';
      //   this.$refs['pageFormApplication'].formData['staffID'] = 7;
      //   this.$refs['pageFormApplication'].formData['staffNo'] = 7;
      //   this.onFilterPasscardChange();
      // }
    },
    loadSeason() {
      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            if(this.pageFees[seasonID] = response.data[0]) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.loadLeaseData();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let license = this.$refs['licenseFilter'].filterData.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + license['_customer']['id'] + '/subscriber/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    showLeaseData() {
      this.showTerminationApplication = true;
      let temp = this.pageLease.filter(k => helper.compareID(k.id ,this.$refs['passcardFilter'].filterValue));
      this.$refs['pageTable'].setTableData(temp);
    },
    checkSeasonFees() {
      for(let leaseData of this.pageLease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    getUrl(licenseID) {
      let url = helper.SERVER_URL + '/api2';
      if(licenseID) {
        url += '/license/' + licenseID;
      }
      url += '/leases/';

      return url;
    },

    onFilterCarparkChange(dataIndex) {
      this.showTerminationApplication = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.$refs['passcardFilter'].setFilterData(null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.showTerminationApplication = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.$refs['passcardFilter'].setFilterData(null);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadTerminationApplication();
    },
    onFilterPasscardChange() {
      this.showLeaseData();
    },

    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Issue Passcard', tableData[tableDataIndex]);
    },
    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.APPLICATION_PARAM_MAP['staffID'], formData['staffID']) || {}
        formData['staffNo'] = staff['personnelCode'];
      }
    },

    async onIssuePasscardClick() {
      let formData = this.$refs['pageModal'].$refs['modalForm'].formData;
      // return;

      let temp = {};
      temp['movements'] = 'Issued';

      let feedbackItem = 'passcard status';
      this.$refs['pageModal'].setModalLoading('Setting ' + feedbackItem);
      // TODO kw1 update passcard status
      let result = true;
      // let result = await this.$http
      //   .put(
      //     helper.SERVER_URL + '/api2/passcard/' + formData['passcardID'],
      //     querystring.stringify(temp),
      //     helper.createAxiosFormConfig()
      //   )
      //   .then(response => {
      //     return true;
      //   })
      //   .catch(error => {
      //     this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', feedbackItem));
      //   });

      if(result) {
        temp = {};
        temp['passcardID'] = formData['passcardID'];

        feedbackItem = 'lease passcard status';
        this.$refs['pageModal'].setModalLoading('Setting ' + feedbackItem);
        this.$http
          .put(
            helper.SERVER_URL + '/api2/leases/' + formData['id'],
            querystring.stringify(temp),
            helper.createAxiosFormConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageModal'].setModalClose();
            this.$refs['pageTable'].setTableData(this.pageLease = null);
            this.loadPasscard();
          })
          .catch(error => {
            this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', feedbackItem));
          });
      }
    },

    onSubmitButtonClick() {
      if(!this.$refs['pageFormApplication'].validateForm()) {
        this.addApplicationData({});
      }
    },

    addApplicationData(data) {
      let feedbackItem = 'passcard return appplication data';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .put(
          helper.SERVER_URL + '/api2/applicationData/',
          querystring.stringify({application: ''}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
          data['applicationDataID'] = response.data;
          this.addApplication(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    addApplication(data) {
      let tempData = {};
      tempData['applicationData'] = data['applicationDataID'];
      tempData['licenseID'] = this.$refs['licenseFilter'].filterValue;
      tempData['leases'] = [].concat(this.pageLease.find(k => helper.compareID(k.id, this.$refs['passcardFilter'].filterValue)));
      tempData['leases'] = JSON.stringify(tempData['leases']);
      
      let feedbackItem = 'passcard return appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePasscardReturn/',
          querystring.stringify(tempData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.approveApplication(response.data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    approveApplication(data) {
      let feedbackItem = 'passcard return appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Approving ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePasscardReturn/' + data[0].id + '/approve',
          querystring.stringify(null),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.updatePasscardMovement();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'approving', feedbackItem));
        })
    },
    updatePasscardMovement() {
      let lease = this.pageLease.find(k => helper.compareID(k.id, this.$refs['passcardFilter'].filterValue));
      let passcard = this.pagePasscard.find(j => helper.compareID(j.id, lease['passcardID']));
      
      passcard['movement'] = 'Returned';
      passcard['carparkID'] = this.pageLicense.carparkID;

      let feedbackItem = 'passcard movement';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/passcard/' + lease.passcardID,
          querystring.stringify(passcard),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          // TODO kw1 go to passcard termination list
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscard_TerminationApplicationView.vue